export const WITHOUT_PROJECT = "without-project";

export function filterTreesByProject(trees, selectedProjectId) {
  if (selectedProjectId == null || !Array.isArray(trees)) {
    return trees || [];
  }
  if (selectedProjectId === WITHOUT_PROJECT) {
    return trees.filter((item) => item?.project_id == null);
  }
  return trees.filter((item) => String(item?.project_id) === String(selectedProjectId));
}
